export enum OrderItemConfirmationScannerPageState {
  SCANNING = 0,
  CHECKING = 1,
  ERROR = 2,
  COMPLETE = 3,
  WRONG_BARCODE = 4,
}
